import script from "./saleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./saleDetail.vue?vue&type=script&setup=true&lang=js"

import "./saleDetail.vue?vue&type=style&index=0&id=448a8ab0&lang=less"

const __exports__ = script;

export default __exports__